/**
 * milk 的字卡抽取核心。
 * 注意：milk 的 3%「拍一拍」属于聊天功能分支，不属于字卡数量算法，
 * 这个无聊天场景只复刻 1/2/3 张分布和放回抽样。
 */

export function getReplyCount(random = Math.random) {
  return random() < 0.75 ? 1 : random() < 0.95 ? 2 : 3;
}

export function buildReplyPool(customReplies, customReplyGroups = [], disabledReplyItems = []) {
  const disabledItems = new Set(disabledReplyItems);
  const disabledGroupItems = new Set();

  customReplyGroups.forEach((group) => {
    if (!group?.disabled || !Array.isArray(group.items)) return;
    group.items.forEach((item) => disabledGroupItems.add(item));
  });

  return (Array.isArray(customReplies) ? customReplies : [])
    .filter((reply) => !disabledItems.has(reply) && !disabledGroupItems.has(reply))
    .map((reply) => String(reply ?? '').trim())
    .filter(Boolean);
}

export const EXAMPLE_CARD = '实例文本';

export function resolveDrawPool(pool) {
  return Array.isArray(pool) && pool.length ? pool : [EXAMPLE_CARD];
}

export function drawMilkCards(pool, random = Math.random) {
  if (!Array.isArray(pool) || pool.length === 0) return [];
  const count = getReplyCount(random);
  const drawn = [];

  for (let index = 0; index < count; index += 1) {
    drawn.push(pool[Math.floor(random() * pool.length)]);
  }

  return drawn;
}

export function calculateRevealTiming(cards, tempo = 'balanced') {
  const graphemeCount = cards.reduce((total, card) => total + splitGraphemes(card).length, 0);
  const count = Math.max(1, cards.length);
  const tempoFactor = tempo === 'quick' ? 0.72 : tempo === 'slow' ? 1.32 : 1;
  const targetBudget = (2200 + count * 1300) * tempoFactor;
  const perCharacter = Math.max(12, Math.min(64, targetBudget / Math.max(20, graphemeCount)));
  const paragraphGap = Math.max(180, Math.min(480, perCharacter * 8));

  return {
    perCharacter,
    paragraphGap,
    totalDuration: graphemeCount * perCharacter + Math.max(0, count - 1) * paragraphGap + 650,
  };
}

export function splitGraphemes(text) {
  const value = String(text ?? '');
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter('zh-CN', { granularity: 'grapheme' });
    return Array.from(segmenter.segment(value), (entry) => entry.segment);
  }
  return Array.from(value);
}
